'use strict';

DoohApps
.directive('heightChangeTarget', [function () {
    return {
        link: function (scope, elem, attrs) {

            scope.$watch('__height', function (newHeight, oldHeight) {
                if ($(window).width() >= 730) {
                    void 0;
                    if (newHeight > 255 || (newHeight == 0 && oldHeight > 255)) {
                        $('.groupsContainer').addClass('overflow');
                        $('.groupsContainer').find('.asset').addClass('lesserMarginRight');
                    }
                    else {
                        $('.groupsContainer').removeClass('overflow');
                        $('.groupsContainer').find('.asset').removeClass('lesserMarginRight');
                    }
                }
            });
        }
    }
}]);